import { useI18n } from '@/i18n'
import type { Component } from 'solid-js'

interface PeatchLogoProps {
  size?: number
  class?: string
}

export const PeatchLogo: Component<PeatchLogoProps> = (props) => {
  const { t } = useI18n()
  const size = () => props.size ?? 32

  return (
    <div
      role="img"
      aria-label={t('peatchLogo.aria')}
      class={`peatch-logo ${props.class ?? ''}`}
      style={{
        width: `${size()}px`,
        height: `${size()}px`,
      }}
    />
  )
}
